import { isInApp } from "@/libs/comeAppSDK";
import { isBrowser, isIOS } from "./browser";
import qs from 'qs';

/** 获取url查询参数 */
export const queryString = <T extends object>(
  url?: string,
): T => {
  if (!isBrowser()) return {} as T;

  const search = url ? new URL(url).search : window.location.search;
  const urlParams = qs.parse(search, { ignoreQueryPrefix: true }) as T;
  return urlParams;
};

/** 区号带上+号 */
export const getPhoneCode = (phoneCountryCode: string) => {
  if (!phoneCountryCode) {
    return phoneCountryCode;
  }
  if (phoneCountryCode.startsWith('+')) {
    return phoneCountryCode;
  }
  return '+' + phoneCountryCode;
};


/**
 * @param { Promise } promise
 * @param { Object= } errorExt - Additional Information you can pass to the err object
 * @return { Promise }
 */
export function awaitTo<T, U = Error>(
  promise: Promise<T>,
  errorExt?: object
): Promise<[U, undefined] | [null, T]> {
  return promise
    .then<[null, T]>((data: T) => [null, data])
    .catch<[U, undefined]>((err: U) => {
      if (errorExt) {
        const parsedError = Object.assign({}, err, errorExt);
        return [parsedError, undefined];
      }

      return [err, undefined];
    });
};

export function toFixed(num: number, len: number) {
  if (typeof num === 'undefined' || isNaN(num)) return '';
  return num % 1 === 0 ? num.toString() : num.toFixed(len);
}

// 解析模板
export function parseTemplate(template, data) {
  const computed = template.replace(/{{(\w+)}}/g, function (_match, key) {
    return data[key];
  });
  return computed;
}

export function showAppDownloadBanner() {
  return !(isInApp() || isIOS());
}